import {AccidentalDeathAndDismembermentBlock} from './AccidentalDeathAndDismemberment';
import {AccidentAmbulanceUrgentCareBlock} from './AccidentUrgentCareBlock';
import {TreatmentSupportAndRecoveryBlock} from './TreatmentSupportAndRecovery';
import {
  AccidentFacilityCareBlock,
  AccidentInjuriesBlock,
  AccidentTreatmentAndUrgentCareFollowUpBlock,
  AccidentTreatmentAndUrgentCareXRayBlock,
} from './ACCBenefits';
import {AdditionalOptionsandBenefitsGAI7Block} from './AdditionalOptionsandBenefitsGAI7';
import {AdditionalOptionsandBenefitsGVA6Block} from './AdditionalOptionsandBenefitsGVA6';
import {UnderwritingBlock} from '../Common/UnderwritingBlock';
import {AvailablePlans, BlocksMap, FormBlock} from '../types';
import {AccidentDiagnosticPainManagementBlock} from './AccidentDiagnosticPainManagement';
import {AccidentEmergencyRoomServicesBlock} from './AccidentEmergencyRoomServices';
import {AccidentSurgeriesBlock} from './AccidentSurgeries';
import {AccidentDislocationAndFractureRiderBlock} from './AccidentDislocationAndFractureRiderBlock';
import {BenefitEnhancementRiderBlock} from './GVA6BenefitEnhancementRider';
import {HospitalBenefitsBlock} from './HospitalBenefitsBlock';
import {AccidentalDeathAndDismembermentGVA6Block} from './GVA6AccidentalDeathAndDisemberment';
import {AccidentTreatmentUrgentCareBlock} from './AccidentTreatmentUrgentCareRiderBlock';
import commonBlocks from '../Common';

const GAI7Blocks: FormBlock[] = [
  {FormBlock: UnderwritingBlock, key: 'underwriting-block'},
  {FormBlock: AccidentFacilityCareBlock, key: 'accident-facility-care-block'},
  {FormBlock: AccidentInjuriesBlock, key: 'accident-injuries-block'},
  {FormBlock: AccidentTreatmentAndUrgentCareFollowUpBlock, key: 'accident-treatment-and-urgent-care-follow-up-block'},
  {FormBlock: AccidentAmbulanceUrgentCareBlock, key: 'accident-ambulance-urgent-care-block'},
  {FormBlock: AccidentTreatmentAndUrgentCareXRayBlock, key: 'accident-treatment-and-urgent-care-x-ray-block'},
  {FormBlock: AccidentEmergencyRoomServicesBlock, key: 'accident-emergency-room-services-block'},
  {FormBlock: AccidentSurgeriesBlock, key: 'accident-surgeries-block'},
  {FormBlock: AccidentDiagnosticPainManagementBlock, key: 'accident-diagnostic-pain-management-block'},
  {FormBlock: TreatmentSupportAndRecoveryBlock, key: 'treatment-support-and-recovery-block'},
  {FormBlock: AccidentalDeathAndDismembermentBlock, key: 'accidental-death-and-dismemberment-block'},
  {FormBlock: AccidentDislocationAndFractureRiderBlock, key: 'accident-dislocation-and-fracture-rider-block'},
  {FormBlock: AdditionalOptionsandBenefitsGAI7Block, key: 'additional-options-and-benefits-gai7-block'},
];

const GVA6Blocks: FormBlock[] = [
  {FormBlock: UnderwritingBlock, key: 'underwriting-block'},
  {FormBlock: HospitalBenefitsBlock, key: 'hospital-benefits-block'},
  {FormBlock: AccidentTreatmentUrgentCareBlock, key: 'accident-treatment-urgent-care-block'},
  {FormBlock: AccidentEmergencyRoomServicesBlock, key: 'accident-emergency-room-services-block'},
  {FormBlock: BenefitEnhancementRiderBlock, key: 'benefit-enhancement-rider-block'},
  {FormBlock: AccidentalDeathAndDismembermentGVA6Block, key: 'accidental-death-and-dismemberment-gva6-block'},
  {FormBlock: AccidentDislocationAndFractureRiderBlock, key: 'accident-dislocation-and-fracture-rider-block'},
  {FormBlock: AdditionalOptionsandBenefitsGVA6Block, key: 'additional-options-and-benefits-gva6-block'},
];

const accidentBlocksMap: BlocksMap = new Map();
accidentBlocksMap.set('GAI7', GAI7Blocks);
accidentBlocksMap.set('GVA6', GVA6Blocks);

export const getAccidentBlocks = (plan: AvailablePlans) =>
  accidentBlocksMap.has(plan) ? [...commonBlocks, ...accidentBlocksMap.get(plan)] : [];
